import { render, staticRenderFns } from "./addpostPoccess.vue?vue&type=template&id=cffac156&scoped=true&"
import script from "./addpostPoccess.vue?vue&type=script&lang=js&"
export * from "./addpostPoccess.vue?vue&type=script&lang=js&"
import style0 from "./addpostPoccess.vue?vue&type=style&index=0&lang=css&"
import style1 from "./addpostPoccess.vue?vue&type=style&index=1&id=cffac156&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cffac156",
  null
  
)

export default component.exports